var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlassian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.46 12.4263H55.5845C55.5845 18.3975 57.9566 24.1243 62.1789 28.3466C66.4012 32.5689 72.1279 34.941 78.0992 34.941H87.2869V43.8119C87.295 56.2351 97.3638 66.3043 109.787 66.3124V16.753C109.787 14.3641 107.85 12.4263 105.46 12.4263Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7817 37.2776H30.9062C30.914 49.7008 40.9827 59.77 53.4064 59.7781H62.5941V68.6774C62.6099 81.1006 72.6856 91.1629 85.1088 91.1629V41.6051C85.1088 39.2154 83.1714 37.2776 80.7817 37.2776Z",
    fill: "url(#paint0_linear_1567_6579)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0892 62.1146H6.21338C6.21338 74.5492 16.2939 84.6294 28.7281 84.6294H37.9446V93.4998C37.9527 105.912 48.0041 115.976 60.4164 116V66.4418C60.4164 64.052 58.4789 62.1146 56.0892 62.1146Z",
    fill: "url(#paint1_linear_1567_6579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1567_6579",
    x1: 84.0416,
    y1: 37.3643,
    x2: 62.9541,
    y2: 59.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1567_6579",
    x1: 60.7768,
    y1: 62.3598,
    x2: 36.3839,
    y2: 86.3593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassian);
export default __webpack_public_path__ + "static/media/atlassian.03ff0036ad11146bb69b3aa2e6be3777.svg";
export { ForwardRef as ReactComponent };